<template>
  <div class="content">
    <div class="left-content">
      <tree-components
        ref="treeComponents"
        :treeList='treeList'
        :defaultProps='defaultProps'
        :activeNode='activeNode'
        @handleNodeChange='handleNodeChange'
        @handleGetTreeList='handleGetTreeList'
        >
      </tree-components>
    </div>
    <div class="right-content">
      <div class="switch-tree">
        <tree-components
          ref="switchTree"
          :showSearch='false'
          :treeList='switchList'
          :defaultProps='defaultProps'
          :activeNode='activeSwitch'
          @handleNodeChange='handleSwitchChange'
          @handleGetTreeList='handleGetTreeList'
          >
        </tree-components>
      </div>
      <div class="main">
        <div class="search-content">
          <el-form :inline="true" :model="filters" size="small" @keyup.enter.native="handleGetData">
            <el-form-item label="时间类型">
              <el-select v-model="filters.timeType" @change="handleTimeTypeChange" style="width: 100px" placeholder="请选择">
                <el-option :value="0" label="日"></el-option>
                <el-option :value="1" label="周"></el-option>
                <el-option :value="2" label="月"></el-option>
                <el-option :value="3" label="时间段"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item >
              <el-date-picker v-if="filters.timeType === 0" v-model="filters.time" type="date" style="width: 160px" key="day" placeholder="选择日期"></el-date-picker>
              <el-date-picker v-if="filters.timeType === 1" v-model="filters.time" type="week" format="yyyy 第 WW 周" key="week" style="width: 160px" placeholder="选择日期"></el-date-picker>
              <el-date-picker v-if="filters.timeType === 2" v-model="filters.time" type="month" style="width: 160px" key="month" placeholder="选择日期"></el-date-picker>
              <el-date-picker v-if="filters.timeType === 3" v-model="filters.daterange" type="daterange" key="daterange" style="width: 280px" range-separator="至" start-placeholder="开始时间" end-placeholder="结束时间"></el-date-picker>
            </el-form-item>
            <el-form-item v-if="filters.timeType === 0 || filters.timeType === 3">
              <el-select v-model="filters.dataType" style="width: 120px" placeholder="请选择">
                <el-option value="hour" label="按小时间隔"></el-option>
                <el-option value="collect" label="按采集间隔"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" size="small" @click="handleGetData">查询</el-button>
            </el-form-item>
          </el-form>
        </div>
        <div class="base-info">
          <p class="title">基本信息</p>
          <p class="info-content">
            <span class="info-item" v-for="item in switchInfo" :key="item.id">{{ item.displayName }}: <span class="info-value">{{ item.value }}</span></span>
          </p>
        </div>
        <div class="realtime-data">
          <div class="realtime-item" v-for="(item, index) in realtimeData" :key="index">
            <p class="type">{{item.type}}</p>
            <p class="value">{{item.value}}</p>
          </div>
        </div>
        <div class="collect-type">
          <el-radio-group v-model="collectType" size="small" @change="handleChartChange">
            <el-radio-button v-for="item in typeList" :key="item.value" :label="item.value" >{{ item.name }}</el-radio-button>
          </el-radio-group>
        </div>
        <div class="chart-content">
          <charts-component ref="chartsComponent" ></charts-component>
        </div>
        <div class="table-content">
          <el-table ref="table" class="simple-table" :data="tableData" size='small' max-height="300px" highlight-current-row fit border >
            <el-table-column v-for="column in columns" header-align="center" :align="column.align?column.align:'center'"
              :prop="column.prop" :label="column.label" :width="column.width" :min-width="column.minWidth"
              :fixed="column.fixed" :key="column.prop" :type="column.type" :formatter="column.formatter" show-overflow-tooltip>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Socket from '@/utils/websocket'
import treeComponents from './components/treeComponents.vue'
import chartsComponent from './components/chartsComponent.vue'
export default {
  name: 'trendAnalysis',
  components: {
    treeComponents,
    chartsComponent
  },
  data () {
    return {
      filters: {
        timeType: 0,
        time: new Date(),
        daterange: [new Date(), new Date()],
        dataType: 'hour'
      },
      realtimeData: [],
      activeNode: '',
      treeList: [],
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      activeSwitch: '',
      activeSwitchName: '',
      switchList: [],
      switchInfo: [],
      webSocket: null,
      webSocketOptions: {
        ip: '',
        key: '',
        path: '',
        port: ''
      },
      dataList: [],
      collectType: 'U',
      unit: 'V',
      codeList: [201, 202, 203],
      typeList: [
        { name: '电压', value: 'U' },
        { name: '电流', value: 'I' },
        { name: '功率', value: 'P' }
      ],
      typeNameList: {
        201: 'A相电压',
        202: 'B相电压',
        203: 'C相电压',
        207: 'A相电流',
        208: 'B相电流',
        209: 'C相电流',
        211: '总有功功率',
        215: '总无功功率',
        223: '总视在功率'
      },
      series: [],
      options: {
        legend: {
          x: 'center',
          data: []
        },
        grid: {
          top: '18%',
          left: '2%',
          right: '2%',
          bottom: '24%'
        },
        tooltip: {
          trigger: 'axis'
        },
        xAxis: {
          type: 'time'
        },
        yAxis: {
          type: 'value'
        },
        series: [],
        dataZoom: [
          { show: true, realtime: true, start: 0, end: 100 },
          { type: 'inside', realtime: true, start: 0, end: 100 }
        ]
      },
      columns: [
        { prop: 'name', label: '名称', minWidth: 100 },
        { prop: 'type', label: '采集类型', minWidth: 100 },
        { prop: 'max', label: '最大值', minWidth: 100, align: 'right' },
        { prop: 'maxTime', label: '最大值发生时间', minWidth: 150, align: 'right' },
        { prop: 'min', label: '最小值', minWidth: 100, align: 'right' },
        { prop: 'minTime', label: '最小值发生时间', minWidth: 150, align: 'right' }
      ],
      tableData: []
    }
  },
  created () {
    Promise.all([
      this.handleGetWebsocketUrl()
    ]).then(() => {
      this.handleGetTreeList()
    })
  },
  methods: {
    handleTimeTypeChange (val) {
      this.filters.time = new Date()
      this.filters.daterange = [new Date(), new Date()]
      this.filters.dataType = 'hour'
    },
    handleGetWebsocketUrl () {
      this.$api.measuringServer.allotMeasuringRealtimeNotifyServer().then((res) => {
        if (res.success) {
          this.webSocketOptions = Object.assign({}, res.data)
          this.handleWebsocketInit()
        }
      })
    },
    handleWebsocketInit () {
      if (this.webSocket !== null) {
        this.webSocket.close()
      }
      let result = {}
      this.webSocket = new Socket({
        url: window.baseConfig.wsAgreement + '://' + this.webSocketOptions.ip + ':' + this.webSocketOptions.port + '/' + this.webSocketOptions.path
      })
      this.webSocket.onopen(() => {
        console.log(this.webSocketOptions.key)
        this.webSocket.send({
          methodCode: '101',
          key: this.webSocketOptions.key
        })
      })
      this.webSocket.onmessage((res) => {
        this.realtimeData = []
        result = Object.assign({}, JSON.parse(res))
        let list = []
        list = result.data
        let data = []
        console.log(list)
        try {
          if (list.length === 1) {
            data = list[0].data
          } else {
            for (let i = 0; i < list.length; i++) {
              console.log(list[i])
              data.push(list[i].data[0])
            }
          }
        } catch (error) {
          console.log(error)
        }
        // for (let i = 0; i < result.data.length; i++) {
        //   list.push(result.data[i])
        // }
        // console.log('data', list, typeof list)
        // this.realtimeData = result.data.map((item) => {
        //   return {
        //     type: this.typeNameList[item[0].pointCode]
        //   }
        // })
        data.sort((a, b) => {
          return a.pointCode - b.pointCode
        })
        console.log('data', data)
        this.realtimeData = data.map((item) => {
          return {
            type: this.typeNameList[item.pointCode],
            value: item.value
          }
        })
        this.handdleWebSocketOnmessage(result)
      })
    },
    handdleWebSocketOnmessage (res) {
      if (res.methodCode === '102') {
        let point = this.codeList.map((item) => {
          return {
            code: item,
            number: 0
          }
        })
        let requsetInfo = {
          id: this.activeSwitch,
          points: point
        }
        this.webSocket.send({
          methodCode: '103',
          measures: [requsetInfo]
        })
      }
    },
    handleNodeChange (data) {
      this.activeNode = data.id
      this.$nextTick(() => {
        this.$refs['treeComponents'].handleSetCurrentKey(this.activeNode)
      })
      this.dataList = this.handleGetAllLeaf([data])
      this.handleGetRoomSwitches()
    },
    handleGetAllLeaf (data) {
      let result = []
      const getLeaf = (nodeList) => {
        nodeList.forEach((item) => {
          if (item.children.length === 0) {
            result.push(item)
          } else {
            getLeaf(item.children)
          }
        })
      }
      getLeaf(data)
      return result
    },
    handleSwitchChange (data) {
      this.activeSwitch = data.id
      this.activeSwitchName = data.name
      this.$nextTick(() => {
        this.$refs['switchTree'].handleSetCurrentKey(this.activeSwitch)
      })
      this.handleGetSwitchInfo()
      this.handleGetData()
      this.handleGetWebsocketUrl()
    },
    handleGetTreeList () {
      this.treeList = []
      this.$api.rentalArea.getRentalAreaTrusteeshipContractForProperty(0, [], '', '', '', '', 1).then((res) => {
        if (res.success) {
          let areaList = []
          res.data.forEach((item) => {
            areaList = areaList.concat(item.areas)
          })
          let areaIdList = areaList.map((item) => {
            return item.id
          })
          this.$api.rentalArea.getSubRentalAreas(areaIdList, 1).then((res) => {
            if (res.success) {
              this.handleTreeList(res.data)
              this.dataList = [res.data[0]]
              // this.activeNode = res.data[0].id
              this.handleNodeChange(res.data[0])
              // this.handleGetRoomSwitches()
            }
          })
        }
      })
    },
    handleTreeList (list) {
      let allListId = list.map((item) => {
        return item.id
      })
      // 找不到parentId的，pid为0
      list.forEach((item) => {
        item.pid = item.parentId
        if (allListId.indexOf(item.parentId) === -1) {
          item.pid = 0
        }
      })
      this.treeList = this.handleRecursion(list, 0)
    },
    handleRecursion (list, pid) {
      let arr = []
      list.forEach((item) => {
        if (item.pid === pid) {
          item.children = this.handleRecursion(list, item.id)
          arr.push(item)
        }
      })
      // console.log(arr)
      return arr
    },
    handleGetRoomSwitches () {
      this.switchList = []
      let requestList = this.dataList.map((item) => {
        return this.$api.rentalArea.getRentalAreaSwitches(item.id)
      })
      Promise.all(requestList).then((res) => {
        if (res[0].success) {
          res.forEach((item) => {
            this.switchList = this.switchList.concat(item.data)
          })
          this.handleSwitchChange(this.switchList[0])
          // console.log(this.switchList)
        }
      })
    },
    handleGetSwitchInfo () {
      this.$api.measure.getMeasuresProperties([this.activeSwitch]).then((res) => {
        if (res.success) {
          // console.log(res)
          this.switchInfo = res.data[0].propertyGroups[0].properties
        }
      })
    },
    handleGetData () {
      this.handleChartData()
    },
    handleChartData () {
      let startTime = ''
      let endTime = ''
      // let codeList = []
      let measures = []
      switch (this.filters.timeType) {
        case 0:
          startTime = this.$moment(this.filters.time).startOf('d').format('yyyy/MM/DD HH:mm:ss')
          endTime = this.$moment(this.filters.time).add(1, 'd').startOf('d').format('yyyy/MM/DD HH:mm:ss')
          break
        case 1:
          startTime = this.$moment(this.filters.time).startOf('week').format('yyyy/MM/DD HH:mm:ss')
          endTime = this.$moment(this.filters.time).endOf('week').add(1, 'd').startOf('d').format('yyyy/MM/DD HH:mm:ss')
          break
        case 2:
          startTime = this.$moment(this.filters.time).startOf('month').format('yyyy/MM/DD HH:mm:ss')
          endTime = this.$moment(this.filters.time).add(1, 'M').startOf('month').format('yyyy/MM/DD HH:mm:ss')
          break
        case 3:
          startTime = this.$moment(this.filters.daterange[0]).startOf('d').format('yyyy/MM/DD HH:mm:ss')
          endTime = this.$moment(this.filters.daterange[1]).add(1, 'd').startOf('d').format('yyyy/MM/DD HH:mm:ss')
          break
      }
      switch (this.collectType) {
        case 'U':
          this.unit = 'V'
          this.codeList = [201, 202, 203]
          break
        case 'I':
          this.unit = 'A'
          this.codeList = [207, 208, 209]
          break
        case 'P':
          this.unit = 'kW'
          this.codeList = [211, 215, 223]
          break
      }
      measures = this.codeList.map((item) => {
        return {
          measureId: this.activeSwitch,
          pointNumber: 0,
          pointCode: item
        }
      })
      if (this.filters.dataType === 'collect') {
        this.$api.measuring.getMeasuringValue2(measures, startTime, endTime, 0, 0).then((res) => {
          if (res.success) {
            this.handleChartInit(res.data)
          }
        })
      } else {
        this.$api.measuring.getMeasuringValueHour2(measures, startTime, endTime, 0, 0).then((res) => {
          if (res.success) {
            this.handleChartInit(res.data)
          }
        })
      }
    },
    handleChartInit (data) {
      this.series = []
      let option = Object.assign({}, this.options)
      let legendData = this.codeList.map((item) => {
        return this.typeNameList[item]
      })
      this.series = data.map((item) => {
        return {
          name: this.typeNameList[item.pointCode],
          data: item.data.data.map((item) =>{
            return {
              value: [item.time, item.value]
            }
          }),
          markPoint: {
            data: [
              { type: 'max', name: '最大值' },
              { type: 'min', name: '最小值' }
            ]
          },
          type: 'line',
          smooth: true
        }
      })
      option.legend.data = legendData
      option.series = this.series
      // console.log(option, legendData, series)
      // 最大最小值table
      this.handleTableData()
      this.$nextTick(() => {
        this.$refs['chartsComponent'].init(option)
      })
    },
    handleChartChange () {
      this.handleChartData()
      this.handleWebsocketInit()
    },
    handleTableData () {
      // this.columns = [
      //   { prop: 'name', label: '名称', minWidth: 100, align: 'left' }
      // ]
      this.tableData = this.series.map((item) => {
        let maxMin = this.handleMaxMin(item.data)
        return {
          name: this.activeSwitchName,
          type: item.name,
          max: maxMin.max.value,
          maxTime: maxMin.max.time,
          min: maxMin.min.value,
          minTime: maxMin.min.time
        }
      })
    },
    handleMaxMin (data) {
      let list = data.map((item) => {
        return {
          value: item.value[1],
          time: item.value[0]
        }
      })
      list.sort((a, b) => {
        return a.value - b.value
      })
      console.log(list)
      return {
        max: {
          ...list[list.length - 1],
        },
        min: {
          ...list[0]
        }
      }
    }
  },
  beforeDestroy () {
    if (this.webSocket !== null) {
      this.webSocket.close()
    }
  }
}
</script>

<style lang="scss" scoped>
.content {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  display: flex;
  .left-content {
    width: 240px;
    height: 100%;
    // border: 1px solid;
    box-sizing: border-box;
  }
  .right-content {
    display: flex;
    margin-left: 16px;
    width: calc(100% - 256px);
    height: 100%;
    // border: 1px solid;
    box-sizing: border-box;
    .switch-tree {
      width: 180px;
      height: 100%;
    }
    .main {
      margin-left: 16px;
      box-sizing: border-box;
      height: 100%;
      width: calc(100% - 196px);
      text-align: left;
      .chart-content {
        margin: 12px 0;
        width: 100%;
        height: 300px;
      }
    }
  }
}

.base-info {
  margin-bottom: 12px;
  .info-item {
    margin-right: 8px;
  }
  .info-value {
    color: #ed6a93;
  }
}

.realtime-data {
  margin: 12px 0;
  display: flex;
  .realtime-item {
    margin-right: 16px;
    padding: 16px;
    width: 180px;
    height: 80px;
    text-align: center;
    box-sizing: border-box;
    background: linear-gradient(180deg, #e8f8ff, #cef);
    .type {
      font-size: 14px;
      margin-bottom: 8px;
    }
    .value {
      font-size: 16px;
    }
  }
}
</style>
